import moment from 'moment';
import React, { useEffect, useState } from 'react'
import apiService from '../../services/api.service';
import DatePickerComponent from './DatePickerComponent';
import QuantityButtonsComponent from './QuantityButtonsComponent';
import 'react-datepicker/dist/react-datepicker.css';
import ProductPriceComponent from '../ProductPriceComponent';
import { useTranslation } from '../../hooks/useTranslation';

function DailyInventory({ product, setProduct, dailyInventoryForm, watch, setValue, getValues, errorsInventoryForm, clearErrors }) {
    const { t } = useTranslation();
    const [dailyInventory, setDailyInventory] = useState([]);
    const [includeDates, setIncludeDates] = useState([]);
    const [availableQuantity, setAvailableQuantity] = useState(null);
    const [availableQuantityLabel, setAvailableQuantityLabel] = useState('');
    const [ticketsLabel, setTicketsLabel] = useState('');

    //get product-daily-inventory
    useEffect(() => {
        if (!dailyInventory.length && product && product.productId && product.enableDailyInventory) {
            apiService.getProductsInventory(moment(new Date()).format('YYYY-MM-DD'), product.productId).then(response => {
                if (response.data.data && !response.data.errors) {
                    setDailyInventory(response.data.data.filter(r => r.isActive));
                }
            })
        }
    }, [])

    //update includeDates
    useEffect(() => {
        if (dailyInventory.length) {
            setIncludeDates(dailyInventory.map(a => {
                return ((a.quantity - a.bookedQuantity) > 0) &&
                    new Date(a.date)
            }));
        }
    }, [dailyInventory])

    // select first date by default
    useEffect(() => {
        (includeDates && includeDates.length) ?
            setValue('dailyInventoryDate', includeDates[0])
            :
            setValue('dailyInventoryDate', null)
    }, [includeDates])

    // on date select, update max on dailyInventoryQuantity.
    useEffect(() => {
        clearErrors('dailyInventoryDate');
        clearErrors('dailyInventoryQuantity');

        let selectedDate = getValues('dailyInventoryDate');
        if (selectedDate) {
            const inventory = dailyInventory.find(p => moment(p.date).format("YYYY-MM-DD") === moment(selectedDate).format("YYYY-MM-DD")) || null;
            if (inventory) {
                const availableQuantity = inventory.quantity - inventory.bookedQuantity;
                setAvailableQuantity(availableQuantity);
                setAvailableQuantityLabel(t('RemainedQuantity') );
                setTicketsLabel(t('Tickets')+' '+t('toPurchase'));

                if (product.maxQuantityPerOrder && (product.maxQuantityPerOrder < availableQuantity)) {
                    setAvailableQuantity(product.maxQuantityPerOrder);
                     setAvailableQuantityLabel(t('AllowedQuantity') );
                     setTicketsLabel(t('Tickets') );
                }

                if (getValues('dailyInventoryQuantity') > availableQuantity) {
                    setValue('dailyInventoryQuantity', null)
                }
            }
        }
    }, [watch('dailyInventoryDate')])

    // update product on quantity select
    useEffect(() => {
        if (getValues('dailyInventoryQuantity') <= availableQuantity && getValues('dailyInventoryQuantity') >= 0) {
            clearErrors('dailyInventoryQuantity');
        }

        if (!Object.keys(errorsInventoryForm).length) {
            setProduct(prod => ({
                ...prod,
                orderActiveDateEnd: getValues('dailyInventoryDate') ? moment(getValues('dailyInventoryDate')).format('YYYY-MM-DD') : null,
                orderActiveDateStart: getValues('dailyInventoryDate') ? moment(getValues('dailyInventoryDate')).format('YYYY-MM-DD') : null
            }))
        } else {
            setProduct(prod => ({
                ...prod,
                orderActiveDateEnd: null,
                orderActiveDateStart: null
            }))
        }
    }, [watch('dailyInventoryQuantity')])

    return (
        <div className="daily-inventory col-12">
            <DatePickerComponent
                setValue={setValue}
                getValues={getValues}
                includeDates={includeDates}
                errorMessage={errorsInventoryForm.dailyInventoryDate ? errorsInventoryForm.dailyInventoryDate.message : null}
            />
            {!!getValues('dailyInventoryDate') &&
                <span className='limit-text'>*{availableQuantityLabel} {availableQuantity}  {ticketsLabel}</span>
            }
            <div className='summary'>
                <div className='pb-3 d-flex justify-content-between align-items-center border-bottom'>
                    <span>{t("Price")}</span>
                    <ProductPriceComponent
                        product={product}
                    />
                </div>
                <div className='border-bottom pb-3'>
                    <QuantityButtonsComponent
                        setValue={setValue}
                        getValues={getValues}
                        availableQuantity={availableQuantity}
                        dailyInventoryForm={dailyInventoryForm}
                        errorMessage={errorsInventoryForm.dailyInventoryQuantity ? errorsInventoryForm.dailyInventoryQuantity.message : null}
                    />
                </div>
                <div className='pb-3 d-flex justify-content-between align-items-center'>
                    <span>{t("Total")}</span>
                    <ProductPriceComponent
                        product={product}
                        multiply={getValues('dailyInventoryQuantity')}
                    />
                </div>
            </div>
        </div>
    )
}
export default DailyInventory;